export let institutionalManagement = [
    {prop: 'orgName', label: '机构名称'},
    {prop: 'provinceName', label: '省份', width: 80},
    {prop: 'orgTypeName', label: '机构类型',  width: 80},
    {prop: 'person', label: '联系人姓名'},
    {prop: 'phone', label: '联系人电话'},
    {prop: 'createTime', label: '创建时间'}
]

export let bathInsTableHeader = [
    {prop: 'orgName', label: '机构名称'},
    {prop: 'provinceName', label: '所属省份'},
    {prop: 'orgCode', label: '机构代码'},
]